import { IsFlagEnabled } from 'components/FeatureFlagged/FeatureFlagged';
import { FLAGS } from 'hooks/useFlags';
import { externalRoutes } from './externalRoutes';
import { routes } from './routes';

export type SectionLink = {
  name: string;
  path: string;
  external: boolean;
  hideWhen?: (isFlagEnabled: IsFlagEnabled) => boolean;
};

type SiteMapProp = {
  [key: string]: {
    sectionName: string;
    links: SectionLink[];
  };
};

export const SiteMap: SiteMapProp = {
  About: {
    sectionName: 'About',
    links: [
      {
        name: 'Roadmap',
        path: routes.roadmap(),
        external: false,
      },
      {
        name: 'News',
        path: routes.news.base(),
        external: false,
      },
      {
        name: 'Team',
        path: routes.team(),
        external: false,
      },
      {
        name: 'Provenance',
        path: 'path',
        external: false,
      },
      {
        name: 'Careers',
        path: externalRoutes.careers(),
        external: true,
      },
    ],
  },
  Story: {
    sectionName: 'Story',
    links: [
      {
        name: 'WebComic',
        path: routes.comic.base(),
        external: false,
      },
      {
        name: 'Lore',
        path: routes.lore.base(),
        external: false,
      },
      {
        name: 'Media',
        path: routes.media(),
        external: false,
      },
      {
        name: `Adrian's Sanctuary`,
        path: routes.adrianSanctuary(),
        external: false,
        hideWhen: (isFlagEnabled) => !isFlagEnabled(FLAGS.hatchening),
      },
    ],
  },
  Legal: {
    sectionName: 'Legal',
    links: [
      {
        name: 'Terms and Conditions',
        path: routes.terms(),
        external: false,
      },
    ],
  },
  Gallery: {
    sectionName: 'Gallery',
    links: [
      {
        name: 'DuskBreakers',
        path: routes.gallery.base(),
        external: false,
        hideWhen: (isFlagEnabled) => isFlagEnabled(FLAGS.newGallery),
      },
      {
        name: 'All Collections',
        path: routes.gallery.base(),
        external: false,
        hideWhen: (isFlagEnabled) => !isFlagEnabled(FLAGS.newGallery),
      },
      {
        name: 'DuskBreakers',
        path: routes.gallery.duskbreakers(),
        external: false,
        hideWhen: (isFlagEnabled) => !isFlagEnabled(FLAGS.newGallery),
      },
      {
        name: 'Gribble Eggs',
        path: routes.gallery.eggs(),
        external: false,
        hideWhen: (isFlagEnabled) => !isFlagEnabled(FLAGS.newGallery),
      },
    ],
  },
  Resources: {
    sectionName: 'Resources',
    links: [
      {
        name: 'FAQ',
        path: routes.faq(),
        external: false,
      },
      {
        name: 'Support',
        path: routes.help(),
        external: false,
      },
    ],
  },
  Play: {
    sectionName: 'Play Now',
    links: [
      {
        name: 'Download launcher',
        path: routes.launcher(),
        external: false,
      },
      {
        name: 'Play to Mint',
        path: routes.playToMint(),
        external: false,
      },
    ],
  },
};
